import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { DropDownButton } from "@tql/ui-components-react/tql/buttons";
import { dotsVertical } from "@tql/ui-components-react/untitled/icons";

import type { ShipmentCheckCall } from "~/shared/schemas/shipment-management-schema";
import { capToTitle } from "~/shared/utils/string-fns.ts";

import { items } from "../../../utils/constants.ts";
import { getEnteredByLabel } from "../../../utils/get-entered-by-label.ts";

export const TrackingHistoryItem = ({
	checkCall,
	onSelect,
	canModify,
	isSaving,
}: {
	checkCall: ShipmentCheckCall;
	onSelect: (checkCall: ShipmentCheckCall, action: string) => void;
	canModify: boolean;
	isSaving: boolean;
}) => {
	const location = [
		[checkCall.city, checkCall.state].filter(Boolean).join(", "),
		checkCall.zip?.trim(),
	]
		.filter(Boolean)
		.join(" ");
	const enteredBy = getEnteredByLabel(checkCall.enteredBy);
	return (
		<div className={"tracking-item"}>
			{checkCall.status ? (
				<div
					className={"tracking-status-text"}
					data-testid={"tracking-history-item-status"}
				>
					{capToTitle(checkCall.status)}
				</div>
			) : null}
			<div className={"tracking-item-header"}>
				<div className={"tracking-meta-text"}>
					{location ? (
						<>
							<span className={"tracking-location-text"}>{location}</span>
							<span aria-hidden={true}>·</span>
						</>
					) : null}
					<span>
						{/* Timestamps have no timezone designator and are already in
						    Eastern time; parse as local so the display is not offset. */}
						{new Date(checkCall.timestamp).toLocaleString("en-US", {
							month: "2-digit",
							day: "2-digit",
							year: "numeric",
							hour: "2-digit",
							minute: "2-digit",
						})}
					</span>
				</div>
				{enteredBy ? (
					<div
						className={
							enteredBy.isSystem
								? "tracking-source-text tracking-source-system"
								: "tracking-source-text"
						}
						title={checkCall.enteredBy ?? undefined}
					>
						{enteredBy.label}
					</div>
				) : null}
			</div>
			<div className={"tracking-item-body"}>
				<div className={"tracking-note-text"}>{checkCall.remark}</div>
				{canModify ? (
					<DropDownButton
						className={"tracking-action-button"}
						disabled={isSaving}
						items={items}
						onItemClick={(e: { item: string }) => onSelect(checkCall, e.item)}
						text={<SvgIcon icon={dotsVertical} size={"large"} />}
					/>
				) : (
					<div aria-hidden={true} className={"tracking-action-placeholder"} />
				)}
			</div>
		</div>
	);
};
